import { env } from './env.js';

/**
 * Cross-origin link: dashboard login → marketing signup.
 *
 * dashboard.kilatcarwash.net and kilatcarwash.net are different origins, so a brand-new
 * operator who lands on the login screen ("New here?") is sent to the
 * marketing site's instant-activation `/signup` (ADR-0015), the mirror of how
 * `apps/marketing/.../redirect-to-dashboard.ts` resolves the dashboard origin
 * for the post-signup handoff. Origin comes from validated env so a self-host
 * / white-label deploy points at its own marketing host.
 */
export function marketingSignupUrl(): string {
  return new URL('/signup', env.marketingOrigin).toString();
}
